// Pointage and mission time: pure helpers shared by the mission's « Temps » card and the « Temps » tab.
// The server computes periods, totals and anomalies (backend/attendance/rules.py); these only name and format them.
import { errorMessage, isVersionConflict } from "./api";

export const TYPE_LABELS = { arrival: "Arrivée", break_start: "Début de pause", break_end: "Fin de pause", departure: "Départ", void: "Annulation" };
// The big button says what the person does now, not the event's name.
export const ACTION_LABELS = { arrival: "Arrivée", break_start: "Pause", break_end: "Reprise", departure: "Départ" };
export const ACTIVITIES = ["on_site", "travel", "preparation"];
export const ACTIVITY_LABELS = { on_site: "Sur place", travel: "Trajet", preparation: "Préparation" };
export const SOURCE_LABELS = { self: "pointé par la personne", on_behalf: "pointé pour elle", manager: "saisi par un responsable" };
export const ANOMALY_LABELS = {
  missing_departure: "Départ manquant",
  break_out_of_sequence: "Pause incohérente",
  break_not_ended: "Pause non terminée avant le départ",
  departure_without_arrival: "Départ sans arrivée",
  long_period: "Durée de plus de 14 h",
  outside_mission_dates: "En dehors des jours de la mission",
  overlap_other_mission: "Chevauche une autre mission",
};

export function formatMinutes(minutes) {
  const m = Math.max(0, Math.round(minutes || 0));
  const h = Math.floor(m / 60);
  const rest = m % 60;
  if (!h) return `${rest} min`;
  return rest ? `${h} h ${String(rest).padStart(2, "0")}` : `${h} h`;
}

// « 4 h 25 sur place · 30 min de trajet »; natures with no time are left out.
export function totalsText(totals) {
  const parts = ACTIVITIES.filter((a) => totals?.[a]).map((a) => `${formatMinutes(totals[a])} ${a === "on_site" ? "sur place" : `de ${ACTIVITY_LABELS[a].toLowerCase()}`}`);
  return parts.length ? parts.join(" · ") : "Aucun temps";
}

function samePerson(a, b) {
  return !!a && !!b && a.kind === b.kind && a.id === b.id;
}

// The signed-in user's own line on the mission, if they are in the team.
export function myEntry(data, userId) {
  return (data?.people || []).find((p) => p.person.kind === "user" && p.person.id === userId) || null;
}

export function canRecordFor(data, person) {
  return (data?.capabilities?.record_for || []).some((p) => samePerson(p, person));
}

// May this event be corrected or cancelled by the signed-in user? Organisers: any active event; others: their own.
export function canChange(data, event, userId) {
  if (event.state !== "active") return false;
  const caps = data?.capabilities || {};
  return !!caps.correct_any || (!!caps.correct_own && event.person.kind === "user" && event.person.id === userId);
}

export function eventsOf(data, person) {
  return (data?.events || []).filter((e) => samePerson(e.person, person));
}

export function attendanceErrorMessage(error, fallback = "Une erreur est survenue. Réessayez.") {
  if (!error?.response) return "Connexion impossible. Vérifiez votre réseau : le pointage n'a pas été enregistré.";
  if (isVersionConflict(error)) return "Les temps viennent d'être modifiés par quelqu'un d'autre : ils ont été rechargés.";
  const detail = error.response.data?.detail;
  if (detail?.code === "open_periods" && Array.isArray(detail.persons)) return `${detail.msg} (${detail.persons.join(", ")})`;
  return errorMessage(error, fallback);
}
